const SIDE_CODES: Array<{pattern: RegExp; groups: number[]}> = [
    {pattern: /^[A-Z]{2}\d{4}$/, groups: [2, 2, 2]},
    {pattern: /^\d{4}[A-Z]{2}$/, groups: [2, 2, 2]},
    {pattern: /^\d{2}[A-Z]{2}\d{2}$/, groups: [2, 2, 2]},
    {pattern: /^[A-Z]{2}\d{2}[A-Z]{2}$/, groups: [2, 2, 2]},
    {pattern: /^[A-Z]{4}\d{2}$/, groups: [2, 2, 2]},
    {pattern: /^\d{2}[A-Z]{4}$/, groups: [2, 2, 2]},
    {pattern: /^\d{2}[A-Z]{3}\d$/, groups: [2, 3, 1]},
    {pattern: /^\d[A-Z]{3}\d{2}$/, groups: [1, 3, 2]},
    {pattern: /^[A-Z]{2}\d{3}[A-Z]$/, groups: [2, 3, 1]},
    {pattern: /^[A-Z]\d{3}[A-Z]{2}$/, groups: [1, 3, 2]},
    {pattern: /^[A-Z]{3}\d{2}[A-Z]$/, groups: [3, 2, 1]},
];

export function normalizeLicensePlate(value: string): string {
    return value.replace(/[^a-z0-9]/gi, '').toUpperCase();
}

/** Mirrors GetSidecodeLicenseplate/FormatLicenseplate from the shop's legacy car module. */
export function formatLicensePlate(value: string): string {
    const plate = normalizeLicensePlate(value);
    if (plate === '' || /^CD[ABFJNST]\d{1,3}$/.test(plate)) {
        return plate;
    }

    const groups = SIDE_CODES.find(({pattern}) => pattern.test(plate))?.groups ?? [2, 2, 2];
    const formatted: string[] = [];
    let offset = 0;

    for (const length of groups) {
        const group = plate.slice(offset, offset + length);
        if (group !== '') {
            formatted.push(group);
        }
        offset += length;
    }

    if (offset < plate.length) {
        formatted.push(plate.slice(offset));
    }

    return formatted.join('-');
}
